import React, { useEffect, useState } from 'react';
import firebase from '@config/firebase.config';
import { useSelector, useDispatch } from 'react-redux';
import { authActionTypes } from '@/store/Auth/Auth.actionTypes';
const database = firebase.firestore();
export const SubscriptionSeatsWarning = () => {
  const [isVisible, setIsVisible] = useState(false);
  const profile = useSelector((state) => state.auth?.profile);
  const companyId = profile?.activeCompany?.companyId;
  const dispatch = useDispatch();

  useEffect(() => {
    if (profile?.role !== 'Admin') return;
    const companyQuery = database.collection('companyDatabase').doc(companyId);

    const unsubscribe = companyQuery.onSnapshot((snapshot) => {
      const companyData = snapshot.data();
      dispatch({
        type: authActionTypes.SET_SUBSCRIPTION_DATA,
        payload: companyData?.subscriptions,
      });
      const isSeatsExhausted =
        companyData?.subscriptions?.occupiedSeats >=
          companyData?.subscriptions?.seats &&
        companyData?.subscriptions?.seatsExhausted;
      if (
        isSeatsExhausted &&
        companyData?.subscriptions?.status === 'active' &&
        companyData?.subscriptions?.subscriptionEndDate?.toDate() > new Date()
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
  };
  if (!isVisible) return null;

  return (
    <div
      className="subscription-warning-banner"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1050,
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <span style={{ fontSize: '14px' }}>
        Your plan has reached the maximum number of seats.&nbsp; In case you
        want to add more seats, Please Modify Seats on your current
        subscription.
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={handleClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#856404',
            fontSize: '18px',
            cursor: 'pointer',
            padding: '4px',
            marginLeft: '8px',
          }}
          title="Close banner"
        >
          ×
        </button>
      </div>
    </div>
  );
};
